export default "__VITE_ASSET__BzEQQo4p__"